import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronDoubleUp';
/** Renders an SVG icon. */
const SvgChevronDoubleUp = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M22.204 23.796a1.126 1.126 0 0 0 1.592-1.592l-7-7a1.126 1.126 0 0 0-1.592 0l-7 7a1.126 1.126 0 0 0 1.592 1.592L16 17.592z"
      />
      <path
        fill="currentColor"
        d="M22.204 15.796a1.126 1.126 0 0 0 1.592-1.592l-7-7a1.126 1.126 0 0 0-1.592 0l-7 7a1.126 1.126 0 0 0 1.592 1.592L16 9.592z"
      />
    </svg>
  );
};
SvgChevronDoubleUp.displayName = displayName;
export default SvgChevronDoubleUp;
